import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@chakra-ui/react";
import { Coupon } from "sdk/promoCodes";
import { PlanType } from "sdk/types";
import { prices } from "~/constants";

interface Props {
  code: string;
  coupon: Coupon;
  type: PlanType;
}

export const CouponInfo: FC<Props> = ({ code, coupon, type }) => {
  const { t } = useTranslation();

  const fullPrice = prices[type];

  return (
    <Text color="th.gray4" variant="small-print">
      {t("planPayment.promoCode.coupon", {
        code,
        durationInMonths: coupon.duration_in_months,
        fullPrice,
      })}
    </Text>
  );
};
